// extracted by mini-css-extract-plugin
export default {"popup_container":"square_popup_container__Yi9c1","popup_header":"square_popup_header__HQV7j","popup_body":"square_popup_body__Ag9fe"};